import { functionsUsEast1 } from '../config/firebase';
import { httpsCallable } from 'firebase/functions';

export interface SophieSource {
  title: string;
  link: string;
}

export interface SophieResponse {
  answer: string;
  sources: SophieSource[];
}

export interface ChatMessage {
  role: 'user' | 'model';
  content: string;
  sources?: SophieSource[];
}

export const sophieService = {
  async querySophie(query: string, chatHistory: ChatMessage[]): Promise<SophieResponse> {
    try {
      // Use the querySophie cloud function
      // Note: The function name must match what is exported in functions/src/index.ts
      const querySophieFn = httpsCallable<{ query: string; history: any[] }, SophieResponse>(
        functionsUsEast1, 
        'querySophie'
      );
      
      const result = await querySophieFn({ 
        query, 
        history: chatHistory.map(msg => ({ 
          role: msg.role, 
          content: msg.content 
        }))
      });
      
      return result.data;
    } catch (error) {
      console.error('Error querying Sophie:', error);
      throw error;
    }
  }
};
